'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PANEL_NAMES = exports.PANEL_NAMES = {
  keyword: 'keyword',
  location: 'location'
};

var ITEM_TYPES = exports.ITEM_TYPES = {
  location: 'location',
  venue: 'venue',
  activity: 'activity',
  favorites: 'favorites',
  links: 'links'
};

var EVENTS = exports.EVENTS = {
  clickKeywordBox: 'Search - Click Keyword Box',
  clickLocationBox: 'Search - Click Location Box',
  selectKeyword: 'Search - Select Keyword',
  selectLocation: 'Search - Select Location'
};

var PANEL_ITEM_LIMIT = exports.PANEL_ITEM_LIMIT = {
  activityMatches: 5,
  history: 3,
  venue: 6
};

var LOCATION_TYPES = exports.LOCATION_TYPES = {
  autocomplete: 'autocomplete',
  history: 'history'
};